export default __webpack_public_path__ + "static/media/game.88a1896b.svg";